import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import classes from '../../../_common/Tables/styles.module.scss';
import Loader from '../../../_common/Loader/Loader';
import Pagination from '../../../_common/Pagination/Pagination';
import AccountHelpers from '../../../../utils/accountHelpers';
import Button from '../../../_common/Form/Buttons/Button';
import Api from '../../../../api/api';
import { getAccountRequest } from '../../../../store/actions/auth';
import { updateTeamMember } from '../../../../store/actions/team';

const TeamTable = ({
  data, className, page, limit, totalPage, onChange,
}) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const isAdmin = AccountHelpers.isInRole('Admin');
  const isLoggedAsSuperAdmin = AccountHelpers.getAdminToken && AccountHelpers.getAdminRefreshToken();
  const isMikeAyvazyan = AccountHelpers.isLoggedInAsMikeAyvazyan();

  const [loading, setLoading] = useState(false);
  const [loginLoad, setLoginLoad] = useState('');

  const trClass = [classes.tr];

  if (className) trClass.push(className);

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  const adminLogin = async (e, id) => {
    e.stopPropagation();

    if (+AccountHelpers.getUser().id !== +id) {
      setLoginLoad(id);

      try {
        AccountHelpers.setAdminData();

        const { data: { token, refreshToken } } = await Api.loginAdminToHealth({ id });

        AccountHelpers.setToken(token);
        AccountHelpers.setRefreshToken(refreshToken);

        await dispatch(getAccountRequest(id));

        window.location.href = '/';
      } catch (err) {
        setLoginLoad('');
        console.warn(err);
      }
    }
  };

  const activate = async (e, user) => {
    e.stopPropagation();

    setLoginLoad(user.id);

    try {
      await dispatch(updateTeamMember({ ...user, active: true }));

      toast.success('Team member activated successfully');
    } catch (err) {
      console.warn(err);
    }

    setLoginLoad('');
  };

  const tableHeader = useMemo(
    () => {
      const header = [
        {
          name: 'Name',
          path: 'name',
        },
        {
          name: 'Username',
          path: 'username',
        },
        {
          name: 'Email Address',
          path: 'email',
        },
        {
          name: 'Role',
          path: 'role',
        },
        {
          name: 'Date Added',
          path: 'createdAt',
        },
      ];

      if (((isAdmin || isMikeAyvazyan) && !isLoggedAsSuperAdmin)) header.push({ name: 'Action', path: 'login' });

      return header;
    },
    [],
  );

  return (
    !data.length && !loading
      ? <div className={classes.notResult}>No Data Found</div>

      : (
        <div className={classes.script_loader_wrapper}>
          { loading && <Loader className={classes.loader_wrapper} />}

          <div className={classes.table_wrapper}>
            <div className={classes.table__border}>
              <table className={classes.table}>

                <thead className={classes.thead}>
                  <tr className={classes.tr}>
                    {tableHeader.map((h) => (
                      <th className={classes.th} key={h.name}>{h.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className={classes.tbody}>
                  {data.map((d) => (
                    <tr className={trClass.join(' ')} key={d.id} onClick={() => navigate(`/team/${d.id}/edit`)}>
                      {tableHeader.map((h) => {
                        const inactiveUser = !d.activationRequest && !d.active;
                        const activateUser = d.activationRequest && !d.active;
                        const isManufacturer = d.role === 'Manufacturer';

                        return (
                          <td className={classes.td} key={h.name}>
                            {h.path === 'login'
                              ? (
                                <Button
                                  title={activateUser ? 'Activate' : inactiveUser ? 'Inactive' : 'Login'}
                                  className={classes.login_btn}
                                  type="button"
                                  reverseColor
                                  disabled={isManufacturer || inactiveUser || +AccountHelpers.getUser().id === +d.id}
                                  loading={loginLoad === d.id}
                                  onClick={(e) => (activateUser ? activate(e, d) : adminLogin(e, d.id))}
                                />
                              )

                              : h.path === 'createdAt'
                                ? moment(d[h.path]).format('MM/DD/YYYY')

                                : d[h.path]}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />
        </div>
      )
  );
};

TeamTable.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  totalPage: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
};

TeamTable.defaultProps = {
  className: '',
};

export default TeamTable;
